import React from 'react';
import { PageLoader } from '@components/pageLoader';
import { Header } from './nav/header';
import { Footer } from './nav/footer';

import '@css/tailwind.css';
import '@css/main.css';

const Layout = ({ children, reverseHeader, unPinHeader, isHome }) => {
  const appHeight = () => {
    if (typeof window === 'undefined') {
      return;
    }
    const doc = document.documentElement;
    doc.style.setProperty('--app-height', `${window.innerHeight}px`);
  };
  typeof window !== 'undefined' && window.addEventListener('resize', appHeight);
  appHeight();

  return (
    <>
      <Header
        reverseHeader={reverseHeader}
        unPinHeader={unPinHeader}
        isHome={isHome}
      />
      <main
        className='w-full absolute top-0 left-0 '
        style={{
          backgroundColor: 'var(--green-tint)',
        }}>
        {children}
        <Footer />
      </main>
      <PageLoader />
    </>
  );
};

export default Layout;
